import clsx from 'clsx'
import { Button, Col, Container, Grid, Row, Typography } from 'gu-ui-kit'
import formStyles from 'modules/Forms/common-form.module.scss'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import useQueryParams from 'utils/hooks/useQueryParams'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import styles from 'modules/Oauth/oauth.module.scss'
import { notificationShow } from 'modules/Notifications/actions'

const OauthCode = () => {
  const { t } = useTranslation()
  const { query } = useQueryParams()
  const writeToClipboard = useWriteToClipboard()
  const dispatch = useDispatch()
  const { sm: isMobile } = useBreakpoint()

  const toClipboard = useCallback((text) => {
    writeToClipboard(text)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  return (
    <Grid>
      <Row justifyContent="center">
        <Col sm="auto">
          <div className={clsx(formStyles['formContainer'], styles['container'])}>
            <div className={formStyles['formContainer__inner']}>
              <Typography variant={'h3'} className={clsx(formStyles.formHeader)}>
                {t('oauth::code.title')}
              </Typography>
              <Typography variant={'p9'} color="text-secondary">
                {t('oauth::code.description')}:
              </Typography>
              <Typography
                title={t('oauth::code.copy_to_buffer')}
                variant={'p8'}
                className={styles['code']}
                onClick={() => toClipboard(query.code || '')}
              >
                {query.code || '—'}
              </Typography>

              <Container display={'flex'} flexJustify={isMobile ? 'center' : 'flex-end'}>
                <Button
                  bgColor={'Label-GU-Primary'}
                  variant={'primary'}
                  onClick={() => toClipboard(query.code || '')}
                >
                  {t('oauth::code.copy_to_buffer')}
                </Button>
              </Container>
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  )
}

export default OauthCode
